import { styled, Typography } from '@material-ui/core';

export const MainBody = styled('main')(() => ({
  width: '100%',
  minHeight: 'calc(100vh - var(--main-header-height))',
}));

export const Container = styled('div')(({ theme }) => ({
  maxWidth: '1200px',
  margin: 'auto',
  marginTop: '150px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    marginRight: '10px',
    marginLeft: '10px',
  },
}));

export const TitleText = styled(Typography)(() => ({
  fontSize: '3rem',
  color: '#fff',
  width: '100%',
  maxWidth: '450px',
  boxSizing: 'border-box',
}));

export const SubTitleText = styled(TitleText)(() => ({
  fontSize: '1rem',
  fontWeight: 'normal',
  padding: '10px',
}));

export const SmallText = styled(SubTitleText)(() => ({
  fontSize: '.8rem',
  padding: '0px',
  margin: '0px',
  overflow: 'hidden',
  maxWidth: '180px',
  maxHeight: '40px',
}));

export const InviteList = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '450px',
  margin: '10px 0px',
}));

export const InviteItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: theme.shadows[5],
  height: '100px',
  borderRadius: '10px',
  width: '100%',
  margin: '8px 0px',
  padding: '5px 20px',
  boxSizing: 'border-box',
}));
